import { Box, Typography, useTheme } from '@mui/material';
import { Construction, HardHat } from 'lucide-react';

import PlaygroundTabsHeader from 'views/playground/components/playground-tabs-header';
import ComponentPalette from 'views/playground/features/playground-base/components/component-palette';
import PlaygroundCharts from 'views/playground/features/playground-base/components/playground-charts';

const Information = () => {
  const theme = useTheme();

  return (
    <>
      <PlaygroundTabsHeader />
      <Box display="flex" flexDirection="column" gap={4}>
        <Box display="flex" flexDirection="column" gap={4}>
          <Box display="flex" gap={4} alignItems="center">
            <Construction size={32} color={theme.palette.secondary.main} />
            <Typography variant="h1" marginBottom={0} color={theme.palette.common.white}>
              Playground
            </Typography>
            <Construction size={32} color={theme.palette.secondary.main} />
          </Box>
          <Typography variant="body1" color={theme.palette.common.white}>
            This is a playground for testing within the BluViu project. It is also used to build new features in a clear structure to
            easily transition from development to deployment.
          </Typography>
          <Typography variant="body1" color={theme.palette.common.white}>
            Above you will find different tabs to help categorize under construction features and visualization tools.
          </Typography>
          <Box display="flex" gap={4} alignItems="center">
            <Typography variant="body1" color={theme.palette.common.white}>
              Do not forget your safety helmets.
            </Typography>
            <HardHat color={theme.palette.secondary.main} />
          </Box>
        </Box>
        <PlaygroundCharts />
        <ComponentPalette />
      </Box>
    </>
  );
};

export default Information;
